// extracted by mini-css-extract-plugin
module.exports = {"container":"ThreeDotsButton--styles-module_container-2iZ88","dot":"ThreeDotsButton--styles-module_dot-1qv9K"};